import React from 'react';

import 'scss/terms.scss';

const Terms = () => (
    <div className="terms">
        <div className="sn-logo" />

        <h3>CAMPAIGN TERMS AND CONDITIONS</h3>

        <p>
            These Campaign Terms and Conditions apply to any Statement of Work for a campaign toward
            content creation services entered into between you (&ldquo;
            <span className="terms--underline terms--bold">Company</span>
            &rdquo;) and Social Native Inc., a Delaware corporation with offices at 9903 S. Santa Monica Blvd. #766, Beverly Hills, CA 90212 (&ldquo;
            <span className="terms--underline terms--bold">Social Native</span>
            &rdquo;), which Statement of Work specifically references these Terms and Conditions.
            &nbsp;The Statement of Work referencing these Terms and Conditions, together with these
            Terms and Conditions are collectively referred to herein as the &ldquo;
            <span className="terms--underline terms--bold">Agreement</span>
            &rdquo; between Company and Social Native regarding the services to be provided to
            Company by Social Native as described in such Statement of Work.
        </p>
        <ol type="1">
            <li>
                <span className="terms--underline">Certain Definitions</span>
                <span>
                    : &nbsp;In addition to capitalized, bolded and underlined terms defined
                    elsewhere in this Agreement, the following terms will have the following
                    meanings when used in this Agreement:
                </span>

                <ol type="a">
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Campaign</span>
                        <span>
                            &rdquo; means a content creation and targeted marketing campaign created
                            and designed by Company, which Company initiates via the Platform, as
                            set forth on an SOW.
                        </span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Campaign Period</span>
                        <span>&rdquo; means the term of a Campaign, as set forth on an SOW.</span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Content</span>
                        <span>
                            &rdquo; means any and all text, images, photographs, audiovisual works,
                            sound recordings, musical works (including when embodied in sound
                            recordings or audiovisual works) and/or any other works subject to
                            protection under the laws of the United States or any foreign
                            jurisdiction, including, without limitation, patent, trademark, trade
                            secret and/or copyright laws, and any other content uploaded to the
                            Platform by Creators in connection with a Campaign and specifically made
                            available for Company&rsquo;s download via the Platform.
                        </span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Creator</span>
                        <span>
                            &rdquo; means any individual that creates or provides Content to Social
                            Native (i)&nbsp;via the Platform or (ii) otherwise in connection with
                            this Agreement, any SOW or any Campaign.
                        </span>
                    </li>
                    <li>
                        <span>&nbsp;&ldquo;</span>
                        <span className="terms--underline terms--bold">Platform</span>
                        <span>
                            &rdquo; means Social Native&rsquo;s online platform, created, operated
                            and owned by Social Native, that, among other things, enables Company to
                            view and download Content, and create new Campaigns, which the Company
                            may access at https://my.socialnative.com/brand/login.
                        </span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Services</span>
                        <span className="terms--bold">&rdquo; </span>
                        <span>
                            means the services that are provided by Social Native to Company
                            pursuant to this Agreement or any SOW. &nbsp;
                        </span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Social Media</span>
                        <span>
                            &rdquo; means Facebook, Twitter, Instagram, YouTube, Snapchat and other
                            social media platforms. &nbsp;
                        </span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Statement of Work</span>
                        <span>&rdquo; or &ldquo;</span>
                        <span className="terms--underline terms--bold">SOW</span>
                        <span>
                            &rdquo; means a statement of work for a Campaign and any addenda,
                            exhibits or supplements thereto. &nbsp;
                        </span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Term</span>
                        <span>&rdquo; has the meaning set forth in Section 6.</span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Territory</span>
                        <span>&rdquo; means the world, unless otherwise specified in an SOW.</span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Under 18 Content</span>
                        <span>
                            &rdquo; means any Content (i)&nbsp;provided by a Creator that was under
                            18 years old at the time such Content was provided to Social Native, or
                            (ii) that features an individual that was under 18 years old at the time
                            such Content was created.
                        </span>
                    </li>
                    <li>
                        <span>&ldquo;</span>
                        <span className="terms--underline terms--bold">Use</span>
                        <span>
                            &rdquo; means to download, reproduce, publicly display, publicly
                            perform, transmit, modify, create derivative works of and otherwise use
                            Content in any and all media, whether now known or hereafter created.
                        </span>
                    </li>
                </ol>
            </li>
            <li>
                <span className="terms--underline">Proprietary Rights and Licenses</span>
                <span>: </span>

                <ol type="a">
                    <li>
                        <span className="terms--underline">License Grants to Company</span>
                        <span>
                            . &nbsp;Subject to the terms and conditions of this Agreement Social
                            Native hereby grants to Company (i)&nbsp;a non-exclusive,
                            non-sublicenseable (except as provided for in an SOW), non-transferable
                            (subject to Section 12(b)) right and license in the Territory during the
                            Term, to access and utilize the Platform, create Campaigns and receive
                            and otherwise access the Services solely for the purposes of initiating
                            Campaigns and accessing Content submitted in response to Campaigns,
                            (ii)&nbsp;an exclusive, non-sublicensable (except as provided for in an
                            SOW), non-transferable (subject to Section 12(b)) right and license in
                            the Territory during the applicable Campaign Period, to Use Content
                            solely for the purpose and subject to the limitations and restrictions
                            set forth in the applicable SOW, and (iii)&nbsp;a non-exclusive,
                            non-sublicenseable (except as provided for in an SOW), non-transferable
                            (subject to Section 12(b)) right and license in the Territory during the
                            Term, to Use Creators&rsquo; names, likenesses, images, voice, online
                            identities (e.g., nicknames, user names, handles), biographical
                            information, statements attributable to Creators and any and all other
                            indicia of personality utilized in connection with the applicable
                            Content and to identify Creators as the source of the Content.
                            &nbsp;Notwithstanding the Term limitations set forth above, Company
                            shall have the right to display the Content published by Company during
                            the Campaign Period in perpetuity and Company shall not be required to
                            delete any historical posts displaying the Content after the end of the
                            Campaign Period.&nbsp;
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">License Grants to Social Native</span>
                        <span>
                            . &nbsp;Subject to the terms and conditions of this Agreement, Company
                            grants Social Native a non-exclusive, non-sublicenseable (except as set
                            forth in Section 2(c)), non-transferable (subject to Section 12(b)),
                            worldwide right and license to use Company&rsquo;s trademarks, trade
                            names, trade dress, service marks, and logos (&ldquo;
                        </span>
                        <span className="terms--underline terms--bold">Company Marks</span>
                        <span>
                            &rdquo;) solely to the extent (i) necessary to grant the sublicense set
                            forth in Section 2(c), and (ii) such Company Marks appear in or are
                            otherwise incorporated in Content contained or displayed in the Platform
                            as authorized pursuant to this Agreement. &nbsp;Except as set forth in
                            this Section 2(b), nothing contained in this Agreement will grant or
                            will be deemed to grant to Social Native or any Creator any right,
                            title, or interest in or to the Company Marks. &nbsp;All uses of the
                            Company Marks and related goodwill will inure solely to Company, and
                            Social Native will obtain no rights or goodwill with respect to any of
                            the Company Marks, other than as expressly set forth in this Agreement,
                            and Social Native irrevocably assigns to Company all such right, title,
                            interest, and goodwill, if any, in any of the Company Marks. &nbsp;
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">Creator Licenses</span>
                        <span>
                            . &nbsp;Notwithstanding anything contained elsewhere in this Agreement,
                            Company acknowledges and agrees that Social Native may grant Creators a
                            non-exclusive, non-sublicenseable, non-transferable, fully paid-up
                            worldwide right and sublicense to (i) reproduce, incorporate, and
                            otherwise use Company Marks solely in Content, (ii)&nbsp;use Company
                            Marks at Company&rsquo;s direction pursuant to a Campaign, (iii) use
                            Company Marks in Creator posts on Social Media that include Content, and
                            (iv) post Content on Social Media.
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">Intellectual Property Ownership</span>
                        <span>
                            . &nbsp;The parties acknowledge and agree that, as between the parties,
                            subject to the licenses granted to Company under Section&nbsp;2(a),
                            Social Native is the exclusive owner of and retains all rights,
                            including all proprietary and intellectual property rights existing now
                            or in the future, of the Content, the Platform and the Services,
                            including any and all intellectual property or work product created in
                            connection with this Agreement (collectively &ldquo;
                        </span>
                        <span className="terms--underline terms--bold">Social Native IP</span>
                        <span>
                            &rdquo;). Notwithstanding the foregoing, the parties acknowledge and
                            agree that, as between the parties, Company is the exclusive owner of
                            the Company Marks, including any Company Marks incorporated into
                            Content. &nbsp;
                        </span>
                    </li>
                </ol>
            </li>
            <li>
                <span className="terms--underline">Access to Content</span>
                <span>
                    : &nbsp;Within 30 days of the expiration or termination of a Campaign Period,
                    the Content of a Campaign will be removed from the Platform and Company will no
                    longer have access to such Content for download (unless there is a Content
                    Shortfall as set forth in Section 4(d)).&nbsp; Company is solely responsible for
                    downloading all Content Company wishes to maintain prior to the expiration of
                    such 30-day period.&nbsp; Social Native will use reasonable efforts to provide
                    Company with electronic notice at least five (5) days prior to the removal of
                    Campaign-specific Content from the Platform. &nbsp;
                </span>
            </li>
            <li>
                <span className="terms--underline">Fees and Payment</span>
                <span>:</span>

                <ol type="a">
                    <li>
                        <span className="terms--underline">Fees</span>
                        <span>
                            . &nbsp;In consideration for the Services, access to the Platform, and
                            the licenses and rights granted by Social Native under the Agreement,
                            Company agrees to pay the fees set forth in each SOW (the &ldquo;
                        </span>
                        <span className="terms--underline terms--bold">Fees</span>
                        <span>&rdquo;)</span>
                        <span className="terms--bold">. </span>
                    </li>
                    <li>
                        <span className="terms--underline">Payment</span>
                        <span>
                            . &nbsp;Unless otherwise set forth in an applicable SOW, the Company
                            shall pay the total aggregate Fees under an SOW within 30 days after the
                            date of execution of such SOW. &nbsp;All payments shall be made in U.S.
                            Dollars in immediately available funds. &nbsp;Payments will be made to
                            Social Native pursuant to the method indicated in the SOW. &nbsp;
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">Late Payment</span>
                        <span>
                            . &nbsp;Any payments or portions thereof due hereunder which are not
                            paid when due shall be subject to a late payment charge equal to three
                            percent (3%) per month, or the maximum rate permitted by applicable law,
                            calculated on the number of days such payment is delinquent. &nbsp;In
                            the event that Company is late on any payments due hereunder, Social
                            Native shall be under no obligation to supply additional Services until
                            such overdue amounts are paid in full. &nbsp;This Section 4(c) shall in
                            no way limit any other remedies available to Social Native.
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">Content Shortfall</span>
                        <span>
                            . The parties acknowledge and agree that it will not be deemed a
                            material breach of the Agreement if Social Native does not provide all
                            Content agreed upon in an SOW for a certain Campaign by the end of the
                            Campaign Period (&ldquo;
                        </span>
                        <span className="terms--underline terms--bold">Content Shortfall</span>
                        <span>
                            &rdquo;). If there is a Content Shortfall, then Social Native will have
                            30 days from the end of the applicable Campaign Period to provide
                            Company with all missing Content.
                        </span>
                    </li>
                </ol>
            </li>
            <li>
                <span className="terms--underline">
                    Certain Representations, Warranties and Covenants
                </span>
                <span>:</span>

                <ol type="a">
                    <li>
                        <span className="terms--underline">
                            Mutual Representations and Warranties
                        </span>
                        <span>
                            . &nbsp;As of the Effective Date and during the Term, each party hereto
                            represents, warrants and covenants that it has the full right, power,
                            and authority to enter into and fully perform this Agreement, and to
                            grant the rights granted herein, in accordance with its terms, and that
                            the person executing this Agreement on behalf of such party is
                            authorized to do so.
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">
                            Social Native Representations and Warranties
                        </span>
                        <span>
                            . &nbsp;Social Native represents, warrants and covenants that (i) it has
                            obtained as of the Effective Date, and will obtain throughout the Term,
                            all authority and third party rights, clearances, and consents necessary
                            for Social Native to provide Company with access to the Platform and the
                            Services; (ii) the Platform and the Services do not and will not
                            infringe, violate, or misappropriate any United States intellectual
                            property rights of any third party; and (iii) its and its Third Party
                            Contractors&rsquo; execution, delivery and performance under or of this
                            Agreement will not violate the provisions of any agreement to which it
                            is a party, or any applicable law. &nbsp;Notwithstanding anything to the
                            contrary in this Agreement, the parties acknowledge and agree that
                            Social Native makes no representations, warranties or covenants with
                            respect to Under 18 Content. &nbsp;Upon written request by Company (or
                            if so specified in the applicable SOW), Social Native shall use
                            commercially reasonable efforts to exclude Under 18 Content from any
                            Content or Campaigns that are part of the Services provided to Company.
                            &nbsp;Company acknowledges that subject to the above requirement, the
                            inadvertent inclusion of Under 18 Content in any Content shall not be
                            considered a breach of this Agreement.
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">
                            Company Representations and Warranties
                        </span>
                        <span>
                            . &nbsp;Company represents, warrants and covenants that (i) it is not
                            involved in litigation, arbitration, or any other claim and knows of no
                            pending litigation, arbitration, other claim, or fact that may be the
                            basis of any claim regarding any Campaign, the Platform or the Content,
                            (ii) its execution, delivery and performance under or of this Agreement,
                            its use of Content and the Platform, and its conducting of Campaigns
                            will not violate the provisions of (1) any agreement to which it is a
                            party, (2) applicable Social Media terms and conditions, or (3) any
                            applicable Laws, and (iii) its Use of Content will be solely in
                            accordance with the grant of rights set forth in this Agreement and for
                            no other purpose without Social Native&rsquo;s prior written consent,
                            which may be withheld for any or no reason.
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">Disclaimers</span>
                        <span>
                            . &nbsp;EXCEPT AS EXPRESSLY SET FORTH IN THIS AGREEMENT, SOCIAL NATIVE
                            PROVIDES THE SERVICES AND PLATFORM &ldquo;AS IS&rdquo; AND WITHOUT ANY
                            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO,
                            THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
                            PURPOSE, TITLE, NON-INFRINGEMENT AND QUALITY. SOCIAL NATIVE IS NOT
                            RESPONSIBLE OR LIABLE FOR ANY HARM TO COMPANY RESULTING FROM
                            COMPANY&rsquo;S USE OF THE CONTENT, PLATFORM OR SERVICES NOT IN
                            ACCORDANCE WITH THE TERMS OF THIS AGREEMENT.
                        </span>
                    </li>
                </ol>
            </li>
            <li>
                <span className="terms--underline">Term</span>
                <span>: The term of the Agreement (&ldquo;</span>
                <span className="terms--underline terms--bold">Term</span>
                <span>
                    &rdquo;) shall commence upon the Effective Date and continue for the duration of
                    the Campaign Period as set forth on the Statement of Work to which this
                    Agreement applies.&nbsp;
                </span>
            </li>
            <li>
                <span className="terms--underline">Termination</span>
                <span>: </span>

                <ol type="i">
                    <li className="c0">
                        <span>
                            Without limiting any other remedy available at law or in equity, either
                            party may terminate the Agreement in the event of any material breach of
                            the Agreement by the other party that is not remedied within thirty (30)
                            days after written notice is provided to the breaching party. &nbsp;To
                            the extent permitted by applicable law, and without limitation, the
                            occurrence of any of the following events shall be considered a material
                            breach of and default under the Agreement: (1) dissolution of and/or the
                            liquidation of all of the assets of the other party; (2) the filing of a
                            petition in bankruptcy or insolvency or for an arrangement or
                            reorganization by, for or against the other party, which is not
                            dismissed within ninety (90) days; (3) the appointment of a receiver or
                            trustee for all or a portion of the assets of the other party, which is
                            not dismissed or removed within ninety (90) days; or (4) the other
                            party&rsquo;s assignment of assets for the benefit of creditors, which
                            are not returned or reversed within ninety (90) days. &nbsp;Company may
                            not terminate the Agreement due to a Content Shortfall (as set forth in
                            Section 4(d)). &nbsp;Any of the foregoing cure periods will not apply to
                            material breaches that are incapable of being cured.
                        </span>
                    </li>
                    <li className="c0">
                        <span>
                            The termination or expiration of the Agreement shall not affect those
                            provisions, representations, warranties and other obligations that by
                            their nature survive the end of the Agreement.
                        </span>
                    </li>
                    <li className="c0">
                        <span>
                            Upon termination or expiration of the Agreement, Company will pay Social
                            Native any and all outstanding Fees.
                        </span>
                    </li>
                    <li className="c0">
                        <span>
                            Upon termination or expiration of the Agreement, all licenses and rights
                            granted to Company to access the Platform or download Content will
                            immediately terminate, provided that Company shall continue to have the
                            right, pursuant to the grant in Section 2(a), to Use Content solely for
                            the purpose set forth in the applicable SOW for the duration of the
                            applicable Campaign Period, subject to the limitations and restrictions
                            set forth in the applicable SOW.
                        </span>
                    </li>
                    <li className="c0">
                        <span>
                            Upon termination or expiration of the Agreement, both parties will,
                            return or destroy or return (at the other party&rsquo;s option) all
                            Confidential Information of the other party.
                        </span>
                    </li>
                </ol>
            </li>
            <li>
                <span className="terms--underline">Indemnification and Insurance</span>
                <span>:</span>

                <ol type="a">
                    <li>
                        <span className="terms--underline">Social Native&rsquo;s Indemnity</span>
                        <span>. &nbsp;Social Native agrees to</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>
                            defend, indemnify, and hold harmless Company, its subsidiaries, its
                            Affiliates, successors, agents, attorneys and assigns, and the officers,
                            directors, shareholders, contractors, members and employees of the
                            foregoing (collectively, &ldquo;
                        </span>
                        <span className="terms--underline terms--bold">Company Parties</span>
                        <span>&rdquo;),</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>
                            from and against any and all Losses arising out of any third-party
                            claim, allegation, action, demand, proceeding or suit (collectively,
                            &ldquo;
                        </span>
                        <span className="terms--underline terms--bold">Claims</span>
                        <span>
                            &rdquo;) against any of the Company Parties that arise directly or
                            indirectly out of (i) infringement or violation of a third party&rsquo;s
                            intellectual property rights by the Platform, Content or Services;
                        </span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>(ii) any</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>facts that, if true, would constitute, a</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>breach by</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>Social Native of the Agreement, including any</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>
                            warranty or representation herein &nbsp;(but, in each case (i) and (ii),
                            excluding Claims directly or indirectly related to Under 18 Content).
                            This Section states the sole liability of Social Native, and the sole
                            remedy of any Company Party, with respect to any third-party claim
                            arising out of any Campaign, the Content, the Platform or the Services.
                            &nbsp; Social Native&rsquo;s obligations to indemnify will not apply to
                            claims to the extent arising from (i) Company&rsquo;s use of the
                            Service, the Content or the Platform in violation of applicable Law or
                            the Agreement; (ii) the combination, operation or use of the Service,
                            Content or Platform with any intellectual property, technology product
                            or service not provided or authorized in writing by Social Native.
                            &nbsp;
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">Company&rsquo;s Indemnity</span>
                        <span>. &nbsp;Company agrees to</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>
                            defend, indemnify, and hold harmless Social Native, its subsidiaries,
                            its Affiliates, successors, agents, attorneys and assigns, and the
                            officers, directors, shareholders, contractors, members and employees of
                            the foregoing (collectively, &ldquo;
                        </span>
                        <span className="terms--underline terms--bold">Social Native Parties</span>
                        <span>&rdquo;),</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>
                            from and against any and all Losses arising out of any Claims against
                            any of the Social Native Parties that arise directly or indirectly out
                            of: (i)
                        </span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>any</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>facts that, if true, would constitute, a</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>breach by</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>Company of the Agreement; (ii)</span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>
                            Company&rsquo;s conducting a Campaign or otherwise using Content; and
                            (iii) Social Native&rsquo;s use of Company Marks, provided that Social
                            Native&rsquo;s use of such marks was in compliance with the terms of the
                            Agreement.
                        </span>
                        <span className="terms--bold">&nbsp;</span>
                        <span>
                            Company acknowledges and agrees that Social Native shall not be
                            liable for any infringement claims brought forth by a
                            third-party arising out of any video content moderated by Social
                            Native that contains music. Company shall be solely liable for
                            any such claims brought forth by any third party.
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">Indemnification Procedures</span>
                        <span>
                            . &nbsp;The persons and entities entitled to be indemnified under
                            Sections 8(a) and 8(b) (individually and collectively, the &ldquo;
                        </span>
                        <span className="terms--underline terms--bold">Indemnitee</span>
                        <span>
                            &rdquo;) shall (i) promptly inform the party obligated to provide
                            indemnification under such sections (the &ldquo;
                        </span>
                        <span className="terms--underline terms--bold">Indemnifying Party</span>
                        <span>
                            &rdquo;) of each Claim with respect to which it seeks indemnity,
                            provided, however, that the failure of the Indemnitee to provide such
                            prompt notice will not relieve the Indemnifying Party of its obligations
                            under this Section 8 unless such failure of prompt notice has materially
                            prejudiced the Indemnifying Party&rsquo;s defense of such Claim, (ii)
                            furnish to the Indemnifying Party a copy of each written communication,
                            notice or other action related to such Claim, suit or proceeding, and
                            (iii) give the Indemnifying Party the authority, information and
                            reasonable assistance necessary to settle or litigate such Claim, using
                            counsel selected by the Indemnifying Party (provided, however, that the
                            Indemnitee shall have the opportunity to participate in the defense of
                            such Claim with counsel of its choice, at the Indemnitee&rsquo;s sole
                            cost). &nbsp;Any settlement of any such Claim by the Indemnifying Party
                            that imposes any requirements on the Indemnitee or which involves
                            agreements other than the payment of money by the Indemnifying Party and
                            receipt of a full release for the benefit of the Indemnifying Party and
                            the lndemnitee shall be subject to the Indemnitee&rsquo;s written
                            consent, not to be unreasonably withheld, conditioned or delayed.
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">Insurance</span>
                        <span>
                            : &nbsp;Throughout the Term, Social Native shall maintain in effect (i)
                            Commercial General Liability insurance providing damage liability
                            coverage, subject to a combined single limit of $2,000,000 per
                            occurrence and $5,000,000 aggregate when combined with umbrella,
                            (ii)&nbsp;Workman&rsquo;s Compensation at statutory limits and Employer
                            Liability, subject to a limit of $1,000,000 each accident, $1,000,000
                            policy limit and $1,000,000 each employee, (iii)&nbsp;Automobile
                            Liability subject to a combined single limit of $2,000,000 and (iv)
                            Errors and Omissions subject to a combined single limit of $5,000,000
                            which includes Media Liability coverage. Such insurance shall include
                            Company as an additional insured. Within thirty (30) days of the
                            Effective Date, Social Native shall furnish Company with certificates of
                            insurance as evidence that the foregoing policy providing the required
                            coverage and limits of insurance is in effect. The certificates shall
                            provide not less than thirty (30) days advance notice to be given in
                            writing to Company prior to cancellation of said insurance.
                        </span>
                    </li>
                    <li>
                        <span className="terms--underline">Limitation of Liability</span>
                        <span>
                            . &nbsp;WITHOUT LIMITING THE INDEMNITY OBLIGATIONS OF THE PARTIES
                            PURSUANT TO THE FOREGOING PROVISIONS OF THIS&nbsp;
                        </span>
                        <span>SECTION 8 </span>
                        <span>
                            AND OTHER THAN AS A RESULT OF A BREACH OF THE CONFIDENTIALITY
                            OBLIGATIONS HEREUNDER, NEITHER PARTY WILL BE LIABLE TO THE OTHER FOR ANY
                            INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR SPECIAL DAMAGES,
                            ARISING OUT OF OR RELATED TO THIS AGREEMENT INCLUDING, WITHOUT
                            LIMITATION, DAMAGES FOR LOSS OF BUSINESS PROFITS, BUSINESS INTERRUPTION,
                            LOSS OF BUSINESS INFORMATION, AND THE LIKE, EVEN IF SUCH PARTY HAS BEEN
                            ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. &nbsp;UNDER NO CIRCUMSTANCES
                            WILL SOCIAL NATIVE&rsquo;S TOTAL LIABILITY OF ALL KINDS ARISING OUT OF
                            OR RELATED TO THIS AGREEMENT, REGARDLESS OF THE FORUM AND REGARDLESS OF
                            WHETHER ANY ACTION OR CLAIM IS BASED ON CONTRACT, TORT, OR OTHERWISE,
                            EXCEED THE TOTAL AMOUNT OF THE INSURANCE COVERAGE MAINTAINED BY SOCIAL
                            NATIVE AS SET FORTH IN SECTION 8(d). &nbsp;
                        </span>
                    </li>
                </ol>
            </li>
            <li>
                <span className="terms--underline">Confidentiality</span>
                <span>: &nbsp;For the purposes of the Agreement, &quot;</span>
                <span className="terms--underline terms--bold">Confidential Information</span>
                <span>&quot;</span>
                <span className="terms--bold">&nbsp;</span>
                <span>
                    shall mean the terms of the Agreement (including this Master Services Agreement
                    and each SOW) and any non-public information, data, reports, or other materials
                    provided by one party to the other under or in connection with the Agreement
                    (other than information expressly intended for public dissemination), and any
                    other information the receiving party should reasonably have understood under
                    the circumstances should be treated as confidential, whether or not the specific
                    designation &quot;confidential&quot; or any similar designation is used, such as
                    royalty reports, and similar information. Notwithstanding any other provisions
                    of this Agreement (including, without limitation, the exceptions to
                    confidentiality described in this Section 9 below), Social Native&rsquo;s
                    Confidential Information shall include a Creator&rsquo;s identity, contact
                    information, and any other information related thereto, in each case, obtained
                    in connection with this Agreement, any SOW or any Campaign (including without
                    limitation via the Platform) (collectively, &ldquo;
                </span>
                <span className="terms--underline terms--bold">Creator Information</span>
                <span>&rdquo;). &nbsp;</span>
                <span>
                    Except with the prior written consent of the disclosing party, neither party
                    shall use or disclose any Confidential Information other than (a) to such
                    party&rsquo;s attorneys, accountants and financial representatives under a duty
                    of confidentiality as may be reasonably necessary in order to receive their
                    professional advice, (b) to such party&rsquo;s employees and contractors who
                    have a need to know for the purposes of the Agreement, and (c) in connection
                    with any legal, governmental or administrative proceeding, provided that prior
                    written notice of such disclosure is furnished to the non-disclosing party in
                    order to afford such non-disclosing party a reasonable opportunity to seek a
                    protective order (it being agreed that if the non-disclosing party is unable to
                    obtain or does not seek
                </span>
                <span className="terms--bold">&nbsp;</span>
                <span>
                    a protective order, disclosure of such information in such proceeding may be
                    made without liability). In addition, the Agreement may be disclosed in
                    contemplation of any merger or sale of all or a substantial portion of a
                    party&rsquo;s assets or securities, subject to a nonuse and nondisclosure
                    agreement consistent with the provisions of this Section 9. &nbsp;Except with
                    respect to Creator Information, nothing in the Agreement shall prohibit or limit
                    either party&#39;s use or disclosure of information (i) previously known to it
                    by lawful means without obligation of confidence, (ii) independently developed
                    by or for it without use of or access to the other party&#39;s Confidential
                    Information, (iii) acquired by it from a third party which, to the reasonable
                    knowledge of the receiving party, is not under an obligation of confidence with
                    respect to such information, (iv) which is or becomes publicly available through
                    no breach of the Agreement or (v) that is required to be disclosed by operation
                    of law, court order or other governmental demand (subject to the notice
                    requirement in clause (c) of this Section 9). &nbsp;The obligations of this
                    Section 9 survive the termination or expiration of the Agreement. &nbsp;
                </span>
            </li>
            <li>
                <span className="terms--underline">Notices</span>
                <span>
                    : &nbsp;All notices under the Agreement must be in writing in order to be
                    effective, and will be delivered to the address specified on the applicable
                    Statement of Work.
                </span>
            </li>
            <li>
                <span className="terms--underline">Dispute Resolution</span>
                <span>
                    : &nbsp;Any controversy or claim arising out of or relating to this Agreement or
                    the breach thereof shall be settled by arbitration administered by the American
                    Arbitration Association (&ldquo;AAA&rdquo;) under its Commercial Arbitration
                    Rules, and judgment on the award rendered by the arbitrator shall be binding and
                    may be entered in any court having jurisdiction thereof. &nbsp;Either party may,
                    at any time by providing thirty (30) days advance written notice to the other,
                    submit their dispute to arbitration. &nbsp;The arbitration shall be held in such
                    location as both parties mutually agree, and if they cannot agree, then the
                    arbitration shall be held in the home jurisdiction of the respondent party.
                    &nbsp;The arbitration shall be conducted in English by one arbitrator mutually
                    acceptable to the parties selected in accordance with AAA Rules. &nbsp;The
                    arbitrator shall not have the power to award any punitive damages or any damages
                    excluded by this Agreement. &nbsp;The parties agree that they shall share
                    equally the cost of the arbitration filing and hearing fees, and the cost of the
                    arbitrator. &nbsp;Each party shall bear its own attorneys&rsquo; fees and
                    associated costs and expenses.
                </span>
            </li>
            <li>
                <span className="terms--underline">Miscellaneous</span>
                <span>
                    : (a)&nbsp;This Agreement is made in accordance with and will be governed and
                    construed under the Laws of the State of California, without reference its
                    conflicts of laws principles. &nbsp;(b)&nbsp;Neither Party may assign any of its
                    rights or obligations under this Agreement without the prior written consent of
                    the other party, except to a successor in interest pursuant to a transfer, sale
                    or divestiture of substantially all of its business to which this Agreement
                    pertains or in the event of its spin-off, merger or consolidation with a third
                    party. &nbsp;Subject to that restriction, this Agreement will be binding on,
                    inure to the benefit of and be enforceable against the parties and their
                    respective successors and assigns. &nbsp;(c)&nbsp;A party&rsquo;s failure to
                    enforce the other party&rsquo;s strict performance of any provision of this
                    Agreement will not constitute a waiver of such party&rsquo;s right to
                    subsequently enforce that provision, or any other provisions of this Agreement.
                    &nbsp;No waiver of any provision hereof will be effective unless in writing and
                    signed by the party against whom such waiver is sought to be enforced.
                    &nbsp;(d)&nbsp;If any term or provision of this Agreement shall for any reason
                    be held invalid, illegal or unenforceable in any respect, such invalidity,
                    illegality or unenforceability shall not affect any other term or provision
                    hereof, and this Agreement shall be interpreted and construed to replace such
                    invalid, illegal or unenforceable term or provision with a new term or provision
                    that has effect as near as possible to the invalid, illegal or unenforceable
                    term or provision without itself being invalid, illegal or unenforceable.
                    &nbsp;(e)&nbsp;Neither party shall be held responsible for any delay or failure
                    in performance hereunder caused in whole or in part by fire, strike, flood,
                    embargo, labor dispute, delay or failure of any subcontract, act of sabotage,
                    riot, accident, delay of carrier or supplier, internet outages, voluntary or
                    mandatory compliance with any governmental act, regulation or request, act of
                    God or by public enemy, or any act or omission or other cause beyond such
                    party&rsquo;s control. &nbsp;(f)&nbsp;The parties are independent contractors,
                    and nothing in this Agreement creates any partnership, joint venture, agency,
                    franchise, sales Company or employment relationship between Company and Social
                    Native. &nbsp;(g)&nbsp;This Agreement is the entire agreement between Company
                    and Social Native with respect to the subject matter hereof. &nbsp;No
                    modification of any of the terms of this Agreement, or any amendments thereto,
                    shall be deemed to be valid unless in writing and signed by an authorized
                    representative of both parties
                    hereto.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
            </li>
        </ol>
    </div>
);

export default Terms;



// WEBPACK FOOTER //
// ./brand/terms_and_conditions/terms_and_conditions.js